import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-documents-dsn',
  templateUrl: './documents-dsn.component.html',
  styleUrls: ['./documents-dsn.component.scss']
})
export class DocumentsDsnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
